import { RefObject } from 'react'

export const handleInsertion = (
  insertion: string,
  setFieldValue: (field: string, value: any) => void,
  values: { message: string },
  inputRef: RefObject<HTMLInputElement>
) => {
  const input = inputRef.current
  if (!input) return

  const newMessage = `${values.message}${insertion}`
  setFieldValue('message', newMessage)

  // Focus the input after insertion
  setTimeout(() => {
    const cursorPosition = newMessage.length
    input.setSelectionRange(cursorPosition, cursorPosition)
    input.focus()
  }, 0)
}

export const handleOptionSelect = (
  option: { id: string; display: string; subtitle?: string },
  setFieldValue: (field: string, value: any) => void,
  values: { message: string },
  inputRef: RefObject<HTMLInputElement>,
  handleMenuClose: () => void
) => {
  const insertion = `[@${option.display}](${option.id}) `
  handleInsertion(insertion, setFieldValue, values, inputRef)
  handleMenuClose()
}

export const handleReactionSelect = (
  reaction: string,
  setFieldValue: (field: string, value: any) => void,
  values: { message: string },
  inputRef: RefObject<HTMLInputElement>
) => {
  const insertion = `[:${reaction}:]( )`
  handleInsertion(insertion, setFieldValue, values, inputRef)
}
